module.exports = __webpack_public_path__ + "static/umber3-4962a08ccf99617f225fea36706fec9f.png";